var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":_vm.target}},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal modal__mask",on:{"click":_vm.close}},[_c('div',{staticClass:"modal__container",class:{
					small: _vm.size == 'small',
					large: _vm.size == 'large',
					auto: _vm.size == 'auto',
					max: _vm.size == 'max',
				},on:{"click":function($event){$event.stopPropagation();}}},[_c('button',{staticClass:"modal__x",on:{"click":_vm.close}},[_vm._v("×")]),_vm._v(" "),_vm._t("modal-content")],2)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }